/// <amd-module name="Widgets/CodeScalarWidget/CodeScalarWidgetDataProvider" />
import { IVssPageContext } from "VSS/Platform/Context";

import { CodeScalarWidgetTfvcRestClient } from "Widgets/CodeScalarWidget/CodeScalarWidgetTfvcRestClient";

import {
    GitQueryCommitsCriteria,
    GitVersionDescriptor,
    GitVersionOptions,
    GitVersionType,
    TfvcChangesetSearchCriteria
} from "VC/Common/Contracts/Git";
import { IGitRestClient } from "VC/Common/RestClient/Git";

export class CodeScalarWidgetDataProvider {
    constructor(private pageContext: IVssPageContext) {}

    public async getData(projectName: string, repositoryId: string, branch: string, path: string): Promise<number> {
        // for git , we get branch from the configuration wih the GB prefix , the new rest api does not work with this and hence we strip it out
        // can revisit this when we change the configuration
        if (branch && branch.startsWith("GB")) {
            branch = branch.substring(2);
        }
        const fromDate = new Date(Date.now() + -7 * 24 * 60 * 60 * 1000).toISOString();

        return branch ? this.getCommitsCount(fromDate, repositoryId, branch, path) : this.getChangesetsCount(fromDate, projectName, path);
    }

    private async getCommitsCount(fromDate: string, repositoryId: string, branch: string, path: string): Promise<number> {
        const gitClient = this.pageContext.getRestClient<IGitRestClient>("IGitRestClient");

        const itemVersion: GitVersionDescriptor = {
            version: branch,
            versionOptions: GitVersionOptions.None,
            versionType: GitVersionType.Branch
        };

        const searchCriteria = {
            itemVersion: itemVersion,
            itemPath: path,
            fromDate: fromDate
        } as GitQueryCommitsCriteria;

        const commits = await gitClient.getCommitsBatch(searchCriteria, repositoryId);
        return commits.length;
    }

    private async getChangesetsCount(fromDate: string, projectName: string, path: string): Promise<number> {
        const tfvcClient = this.pageContext.getRestClient<CodeScalarWidgetTfvcRestClient>("CodeScalarWidgetTfvcRestClient");

        const searchCriteria = {
            itemPath: path,
            fromDate: fromDate
        } as TfvcChangesetSearchCriteria;

        const changesets = await tfvcClient.getChangesets(projectName, searchCriteria);
        return changesets.length;
    }
}
